import React from "react";

// Source
import * as HelperSrc from "../HelperSrc";
import * as ModelRole from "../model/Role";
import * as ModelRoute from "../model/Route";
import * as ModelCustomRoute from "../model/custom/Route";
import * as ModelPreference from "../model/Preference";
import StoreRole from "../store/Role";
import StoreRoute from "../store/Route";
import StorePreference from "../store/Preference";

export default class ControllerSidebar {
    // Variable
    private storeRole: ModelRole.Istore;
    private storageRoleData = React.useRef<ModelRole.Idata | undefined>(undefined);
    private storeRoute: ModelRoute.Istore<ModelCustomRoute.Idata>;
    private storageRouteData = React.useRef<ModelCustomRoute.Idata | undefined>(undefined);
    private storePreference: ModelPreference.Istore<ModelPreference.Idata>;
    private storagePreferenceData = React.useRef<ModelPreference.Idata | undefined>(undefined);

    private elementContainer = React.useRef<HTMLElement | null>(null);
    private elementViewMain = React.useRef<HTMLElement | null>(null);

    private isRendered = React.useRef<boolean>(false);
    private classSidebarOpen = React.useRef<string>("open");

    getStorageRole: ModelRole.Idata | undefined;
    getStorageRoute: ModelCustomRoute.Idata | undefined;

    // Method
    constructor(isRendered: boolean) {
        this.storeRole = new StoreRole();
        this.storageRoleData.current = this.storeRole.storageGet();
        this.storeRoute = new StoreRoute();
        this.storageRouteData.current = this.storeRoute.storageGet();
        this.storePreference = new StorePreference();
        this.storagePreferenceData.current = this.storePreference.storageGet();

        this.isRendered.current = isRendered;

        const [getStorageRole] = React.useState<ModelRole.Idata | undefined>(this.storageRoleData.current);
        this.getStorageRole = getStorageRole;
        const [getStorageRoute] = React.useState<ModelCustomRoute.Idata | undefined>(this.storageRouteData.current);
        this.getStorageRoute = getStorageRoute;
    }

    initializeHook = (): void => {
        React.useEffect(() => {
            HelperSrc.domObserver(".view_sidebar", () => {
                this.initializeHtmlElement();
            });
        }, []);

        React.useEffect(() => {
            this.storageRoleData.current = this.storeRole.storageGet();
            this.storageRouteData.current = this.storeRoute.storageGet();
            this.storagePreferenceData.current = this.storePreference.storageGet();
        }, [this.storageRoleData.current, this.storageRouteData.current, this.storagePreferenceData.current]);

        if (
            this.storagePreferenceData.current &&
            this.storagePreferenceData.current.sidebar &&
            this.elementContainer.current &&
            this.elementViewMain.current
        ) {
            this.elementContainer.current.classList.add(this.classSidebarOpen.current);
            this.elementViewMain.current.classList.add(this.classSidebarOpen.current);
        }
    };

    clickArrow = (): void => {
        if (this.elementContainer.current && this.elementViewMain.current) {
            this.elementContainer.current.classList.toggle(this.classSidebarOpen.current);
            this.elementViewMain.current.classList.toggle(this.classSidebarOpen.current);
        }

        if (this.storagePreferenceData.current) {
            this.storagePreferenceData.current = {
                ...this.storagePreferenceData.current,
                sidebar: this.storagePreferenceData.current.sidebar ? false : true
            };

            this.storePreference.storageSet(this.storagePreferenceData.current);
        }
    };

    private initializeHtmlElement = (): void => {
        if (!this.elementViewMain.current) {
            this.elementContainer.current = document.querySelector<HTMLElement>(".page_container");
            this.elementViewMain.current = document.querySelector<HTMLElement>(".view_sidebar");
        }
    };
}
